import { useCallback } from 'react';
import { usePointOfInterestTemplateLazyQuery } from '@/__generated__/graphql';

type DownloadJsonProps = {
  poiId: string;
  fileName: string;
};

export const useDownloadJson = ({ poiId, fileName }: DownloadJsonProps) => {
  const [getPointOfInterestTemplate] = usePointOfInterestTemplateLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const downloadJson = useCallback(() => {
    getPointOfInterestTemplate({
      variables: {
        pointOfInterestTemplateId: poiId,
      },
    })
      .then(({ data }) => {
        const poiTemplate = JSON.parse(
          JSON.stringify(data?.pointOfInterestTemplate),
          (key, value) => {
            return key === '__typename' ? undefined : value;
          }
        );
        const jsonData = JSON.stringify(poiTemplate, undefined, 2);
        const jsonBlob = new Blob([jsonData], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(jsonBlob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error(error));
  }, [getPointOfInterestTemplate, poiId, fileName]);

  return { downloadJson };
};
